export enum OpportunityAlignment {
    OPPORTUNITY_USER_CLICK = 'oa.opportunityUserClick',
    OPPORTUNITY_METRIC_CLICK = 'oa.opportunityMetricClick',
}
